import { render, staticRenderFns } from "./ManageRedirectionModal.vue?vue&type=template&id=22d5c84c&"
import script from "./ManageRedirectionModal.vue?vue&type=script&lang=js&"
export * from "./ManageRedirectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d5c84c')) {
      api.createRecord('22d5c84c', component.options)
    } else {
      api.reload('22d5c84c', component.options)
    }
    module.hot.accept("./ManageRedirectionModal.vue?vue&type=template&id=22d5c84c&", function () {
      api.rerender('22d5c84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ManageRedirectionModal.vue"
export default component.exports